<template>
  <div class="orderGoods">
    <div class="total">{{ cartInfo.length }} {{$t('message.order.item')}}</div>
    <div class="goodWrapper">
      <div class="item acea-row row-between-wrapper"
        v-for="cart in cartInfo"
        :key="cart.id">
        <div class="pictrue">
          <img v-if="gameState==2" :src="cart.productInfo.up_image.replace('https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png',$t('message.img.goods_img_return'))" class="image" />
          <img v-else :src="cart.productInfo.image.replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',$t('message.img.goods_img_10'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',$t('message.img.goods_img_50'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',$t('message.img.goods_img_5'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',$t('message.img.goods_img_150'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',$t('message.img.goods_img_25'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',$t('message.img.goods_img_500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',$t('message.img.goods_img_1500'))
          .replace('https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',$t('message.img.goods_img_2500'))" class="image" />
        </div>
        <div class="text">
          <div class="acea-row row-between-wrapper">
            <div class="name line1" v-if="gameState==2">{{ cart.productInfo.up_store_name.replace('Double refund',$t('message.goods.name1'))
              .replace('Cash x2 returns',$t('message.goods.name2'))
              .replace('70 times refund(VIP1)',$t('message.goods.name3'))
              .replace('Cash x 72 returns',$t('message.goods.name4')) }}</div>
            <div class="name line1" v-else>{{ cart.productInfo.store_name.replace('Double refund',$t('message.goods.name1'))
              .replace('Cash x2 returns',$t('message.goods.name2'))
              .replace('70 times refund(VIP1)',$t('message.goods.name3'))
              .replace('Cash x 72 returns',$t('message.goods.name4')) }}</div>
            <div class="num">x {{ cart.cart_num }}</div>
          </div>
          <div class="attr line1" v-if="cart.productInfo.attrInfo">
            {{ cart.productInfo.attrInfo.suk }}
          </div>

          <div class="money font-color-red"  v-if="gameState==2">₫{{ parseInt(cart.upTruePrice)|MoneyFormat }}</div>
          <div class="money font-color-red" v-else>₫{{ parseInt(cart.truePrice)|MoneyFormat }}</div>
          <div class="evaluate" v-if="evaluate === 3"
            @click="$router.push({ path: '/goods_evaluate/' + cart.unique })">
            评价
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "OrderGoods",
  props: {
    evaluate: Number,
    cartInfo: {
      type: Array,
      default: () => []
    },
    gameState:{
      type: String,
      default:0,
    }
  },
  data: function() {
    return {};
  },
  mounted: function() {},
  methods: {}
};
</script>
